const DEFAULT_BASE_URL = "https://www.webuycars.co.za";

const BASE_URL = (import.meta.env.VITE_WBC_BASE_URL ?? DEFAULT_BASE_URL).replace(/\/+$/, "");

/**
 * The MID comes straight off the URL, so it is treated as untrusted input.
 * Only a conservative slug charset survives; anything else is dropped and the
 * links fall back to their un-suffixed form rather than building a broken URL.
 *
 * @param {string | undefined} mid
 * @returns {string | undefined}
 */
export function sanitizeMid(mid) {
  if (!mid) return undefined;
  const trimmed = mid.trim();
  if (!/^[A-Za-z0-9][A-Za-z0-9._-]{0,63}$/.test(trimmed)) return undefined;
  return encodeURIComponent(trimmed);
}

/**
 * @param {string | undefined} mid
 * @returns {{ sellMyCar: string, buyACar: string, rateUs: string }}
 */
export function buildLinks(mid) {
  const id = sanitizeMid(mid)?.toUpperCase();
  const suffix = id ? `${id}` : "";

  return {
    sellMyCar: `${BASE_URL}/sell-my-car?locationCode=${suffix}`,
    buyACar: `${BASE_URL}/cars-for-sale`,
    rateUs: `${BASE_URL}/rate-us/${suffix}`,
  };
}